import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEMO_PATH } from './fieldTeamRoutes';

type Props = {
  onGetStarted: () => void;
};

export const FieldTeamStickyCta: React.FC<Props> = ({ onGetStarted }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('ftl-hero');
    if (!hero || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0.15 },
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;

  return (
    <>
      <div className="ftl-sticky-spacer" aria-hidden="true" />
      <div className="ftl-sticky" role="region" aria-label={t('ftl_sticky_copy')}>
        <div className="ftl-sticky-inner">
          <p className="ftl-sticky-copy">{t('ftl_sticky_copy')}</p>
          <div className="ftl-sticky-actions">
            <button type="button" className="dcl-btn dcl-btn--primary dcl-btn--sm dcl-btn--pill" onClick={onGetStarted}>
              {t('ftl_cta_signup_free')}
            </button>
            <Link to={DEMO_PATH} className="dcl-btn dcl-btn--secondary dcl-btn--sm dcl-btn--pill ftl-sticky-demo">
              {t('ftl_cta_demo')}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldTeamStickyCta;
